import axios from "axios";
import env from "@/api/_env";

const client = axios.create({
  baseURL: `${env.endpoint}`,
  headers: env.public
});

export default client;
